import styles from "./methodType.module.scss";
import {
  useCallback,
  useEffect,
  useMemo,
  useState
} from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";

type MethodTypeProps = {
  methodId: number;
}

export const MethodType = ({ methodId }: MethodTypeProps) => {

  const [method, setMethod] = useState<string>();

  const methods = useSelector((state: RootState) => state.mainSlice.methods);

  const findAndSelectMethod = useCallback((): void => {
    const methodName = methods.find(item => item.id === methodId)?.name;
    setMethod(methodName);
  }, [methodId, methods, setMethod]);

  useEffect(() => {
    findAndSelectMethod();
  }, [findAndSelectMethod]);

  const styleName = useMemo((): string => {
    switch (method) {
      case "GET":
        return styles.get;
      case "POST":
        return styles.post;
      case "PUT":
        return styles.put;
      case "DELETE":
        return styles.delete;
      case "PATCH":
        return styles.patch;
      default:
        return "";
    }
  }, [method])

  return (
    <div className={`${styles.container} ${styleName}`}>
      {method}
    </div>
  )
}
